import { getForm } from "./form"

declare global {
  interface Window {
    onOauthScopeChange: (event: Event, formId: string) => void
  }
}

/**
 * Keeps each domain's scopes consistent on the consent form: ticking `<domain>:write` ticks
 * `<domain>:read` too, unticking `<domain>:read` unticks `<domain>:write`.
 */
window.onOauthScopeChange = (event, formId) => {
  const input = event.target as HTMLInputElement
  const form = getForm(formId)

  if (!form || !input) {
    return
  }

  const [domain, access] = input.name.split(":")

  if (access === "write" && input.checked) {
    const readInput = form.querySelector<HTMLInputElement>(`input[name="${domain}:read"]`)

    if (readInput) {
      readInput.checked = true
    }
  }

  if (access === "read" && !input.checked) {
    const writeInput = form.querySelector<HTMLInputElement>(`input[name="${domain}:write"]`)

    if (writeInput) {
      writeInput.checked = false
    }
  }
}
